import { ScreenSize, PanelMode } from "@/design-system/foundations/types";

export const mdsBreakpointsValue = {
  [ScreenSize.Phone]: "(max-width: 520px)",
  [ScreenSize.Tablet]: "(min-width: 521px) and (max-width: 900px)",
  [ScreenSize.Desktop]: "(min-width: 901px)",
} as const;

export const mdsSidebarWidthsValue = {
  expanded: 240,
  collapsed: 80,
} as const;

export const mdsPanelBreakpoint = "688px";

export const mdsPanelWidthsValue = {
  min: 375,
  narrow: 480,
  headerBreakpoint: 688,
  gutter: 8,
} as const;

export type MDSBreakpoints = typeof mdsBreakpointsValue;
export type MDSSidebarWidths = typeof mdsSidebarWidthsValue;
export type MDSPanelWidths = typeof mdsPanelWidthsValue;

// Function versions for backward compatibility
export const mdsBreakpoints = (): Record<ScreenSize, string> => mdsBreakpointsValue;
export const mdsSidebarWidths = () => mdsSidebarWidthsValue;
export const mdsPanelWidths = () => mdsPanelWidthsValue;

const PANEL_COUNT = 2;
const panelNarrowMax = mdsPanelWidthsValue.narrow - 1;
export const mdsPanelModeBreakpoints = {
  [PanelMode.Narrow]: `(max-width: ${panelNarrowMax}px)`,
  [PanelMode.MediumSinglePanel]: `(min-width: ${mdsPanelWidthsValue.narrow}px) and (max-width: ${mdsSidebarWidthsValue.expanded + 1.5 * mdsPanelWidthsValue.min + mdsPanelWidthsValue.gutter - 1}px)`,
  [PanelMode.MediumSplitView]: `(min-width: ${mdsPanelWidthsValue.narrow}px) and (max-width: ${mdsSidebarWidthsValue.expanded + PANEL_COUNT * mdsPanelWidthsValue.min + PANEL_COUNT * mdsPanelWidthsValue.gutter - 1}px)`,
  [PanelMode.WideSinglePanel]: `(min-width: ${mdsSidebarWidthsValue.expanded + 1.5 * mdsPanelWidthsValue.min + mdsPanelWidthsValue.gutter}px)`,
  [PanelMode.WideSplitView]: `(min-width: ${mdsSidebarWidthsValue.expanded + PANEL_COUNT * mdsPanelWidthsValue.min + PANEL_COUNT * mdsPanelWidthsValue.gutter}px)`,
} as const;
